import React from 'react'
import VideoPlayer from './PlainVideoPlayer'
import TButton from '../wp-adons/TButton'
import BackgroundImage from '../wp-adons/BackgroundImage'
import ResponsiveImage from '../PageComponents/ResponsiveImage'
import { setMargin, setPadding } from '../utilities'

export default function VideoSection ({
  pageName,
  title,
  sub_title,
  video_url,
  button_url,
  video_icon,
  video_poster,
  background_image,
  margin_selection,
  padding_selection,
  ...props
}) {
  const pageStyles = {
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  return (
    <div
    style={{ ...pageStyles }}
      className='min-h-svh flex items-center flex-col justify-center relative z-0'
      id={pageName}
    >
      {video_url && (
        <span className='absolute w-full h-full bg-black/50 z-[1]'></span>
      )}
      {video_icon && <div className='relative z-10 flex max-w-[244px] max-h-[244px] items-center justify-center'>
        <ResponsiveImage image={video_icon} /></div>}
      {title && (
        <p
          className='relative z-10 linehight font-text_highlight text-color_light text-header1 md:text-mini_giant lg:text-giant font-medium max-w-sitemax text-center mb-10'
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <span className='text-color_highlight hidden'></span>
      {sub_title && (
        <p className='font-text_readable relative z-10 text-[1.5rem] sm:text-[2rem] lg:text-[3rem] text-color_light max-w-sitemax text-center'>
          {sub_title}
        </p>
      )}
      {button_url && (
        <div className='relative z-20 mt-12'>
          <TButton {...button_url} />
        </div>
      )}
      {video_url && (
        <VideoPlayer
          className='hidden lg:block absolute top-0 left-0 w-full h-full object-cover z-0'
          videoSrc={video_url}
          poster={video_poster?.url}
          autoPlay
          playsInline
          loop
          muted
        />
      )}
      {background_image && (
        <div className='absolute z-0 w-full h-full lg:hidden'>
          {' '}
          <BackgroundImage background_image={background_image} />
        </div>
      )}
    </div>
  )
}
